module.exports = __webpack_public_path__ + "img/step-type-ico.13b85432.svg";